import { $$ } from './utils/querySelector';

export function cf7Checkbox(selector = '.wpcf7-checkbox [type="checkbox"]') {
    function onChange(event) {
        const label = event.target.parentElement;

        if (event.target.checked) {
            label.classList.add('gh-checked');
        } else {
            label.classList.remove('gh-checked');
        }
    }

    const chkboxes = $$()(selector);

    if (!chkboxes) return;

    for (let chkbox of chkboxes) {
        chkbox.addEventListener('change', onChange);
    }
}
